<template>
  <div>
    <api-error v-if="apiError"
               :text="apiErrorText"
               @close="logout">
    </api-error>
    <header-component :username="username"
                      :role="role"
                      @logout="logout">
    </header-component>
    <body-component :username="username"
                    :session-token="sessionToken"
                    :error="error"
                    :role="role"
                    @apierror="setApiError"
                    @apierrortext="setApiErrorText"
                    @loginsuccess="login"
                    @username="setUsername">
    </body-component>
    <footer class="footer" style="font-size:9pt;">
      Copyright &copy; {{ currentYear }}
        <a href="https://www.prairiefarms.com" target="_blank"><b>Prairie Farms Dairy, Inc.</b></a> All rights reserved.
    </footer>
  </div>
</template>

<script>
import ApiError from '@/components/error/ApiError'
import HeaderComponent from '@/components/HeaderComponent'
import BodyComponent from '@/components/BodyComponent'

export default {
  name: 'MainComponent',
  emits: ['loginFailure', 'username'],
  data: function () {
    return {
      apiError: false,
      apiErrorText: null,
      sessionToken: null,
      error: null,
      username: null,
      role: null,
      emitter: null,
      currentYear: null,
    }
  },
  components: {
    ApiError,
    BodyComponent,
    HeaderComponent,
  },
  methods: {
    login(event) {
      this.error = null
      this.role = event.data.role
      this.sessionToken = event.data.id
    },
    setUsername(username) {
      this.username = username
    },
    logout() {
      this.apiError = false
      this.apiErrorText = ''
      this.username = null
      this.passphrase = null
      this.role = null
      this.sessionToken = null
      this.error = null
      this.$store.commit('logout')
    },
    errored() {
      this.error = true
      this.sessionToken = null
      this.role = null
    },
    created() {
      this.emitter.on('loginFailure', error => {
        this.username = null
        this.sessionToken = null
        this.error = error
      })
      this.emitter.on('set-username', username => {
        this.username = username
      })
    },
    setApiError: function (apiError) {
      this.apiError = apiError
    },
    setApiErrorText: function (apiErrorText) {
      this.apiErrorText = apiErrorText
    },
  },
  mounted() {
    this.currentYear = new Date().getFullYear()
  },
}
</script>
